<template>
  <BModal
    v-model="show"
    hide-footer
    hide-header
    size="md"
    centered
    @hide="onHide"
  >
    <div
      v-if="item"
      class="news-popup"
    >
      <button
        class="close news-popup-close"
        @click="close"
      >
        <i class="far fa-xmark" />
      </button>
      <div class="small text-secondary mb-2">
        <i class="far fa-sparkles mr-1" />
        {{ $t('news.popupHeader') }}
      </div>
      <NewsLabels
        :item="item"
        long-date
      />
      <h4 class="mt-2">
        {{ item.title }}
      </h4>
      <img
        v-if="item.thumbnail && item.thumbnail.url"
        :src="item.thumbnail.url"
        class="news-popup-cover mb-3"
      >
      <p class="news-popup-summary">
        {{ item.summary }}
      </p>
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-outline-secondary mr-2"
          @click="close"
        >
          {{ $t('news.close') }}
        </button>
        <button
          class="btn btn-primary"
          @click="readMore"
        >
          {{ $t('news.readMore') }}
        </button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NewsLabels from './NewsLabels';

// Shown on every page load until the user opens ("Czytaj więcej") or dismisses
// ("Zamknij", X, Esc, backdrop) the announcement. The backend picks the item.
export default {
  data: () => ({
    item: null,
    show: false,
    opened: false,
  }),
  components: {
    NewsLabels,
  },
  computed: {
    ...mapGetters(['payeeId']),
  },
  methods: {
    ...mapActions(['getNewsPopup', 'openNews', 'dismissNews']),
    async load() {
      try {
        this.item = await this.getNewsPopup();
        this.show = !!this.item;
      } catch {
        this.item = null;
      }
    },
    close() {
      this.show = false;
    },
    readMore() {
      this.opened = true;
      this.show = false;
      this.openNews(this.item.id).catch(() => {});
      this.$router.push(`/payee/${this.payeeId}/messages/news/${this.item.id}`);
    },
    onHide() {
      if (this.item && !this.opened) {
        this.dismissNews(this.item.id).catch(() => {});
      }
    },
  },
  created() {
    this.load();
  },
};
</script>

<style lang="scss" scoped>
.news-popup {
  position: relative;
  padding: 10px;
}

.news-popup-close {
  position: absolute;
  top: 0;
  right: 0;
}

.news-popup-cover {
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: 12px;
}

.news-popup-summary {
  color: #555;
}
</style>
